import React, { useState } from "react";
import arrow from "../assets/kangaroo/arrow-cropped.svg";
import { Col, Container, Row } from "reactstrap";
import FormClosepink from "../component/FormClosePink/FormClosepink";
import NewsLetterService from "../services/NewsLetterService";
import FormClose from "../component/FormClose/FormClose";
import { toast } from 'react-hot-toast';
// import arrow from '...'; // your arrow image import

const SmallPage = ({ countryPage, institutionPage }) => {
  const [thankYouModal, setThankYouModal] = useState(false);
  const [email, setEmail] = useState('');
  const [isMobile] = useState(window.innerWidth < 768);
  const [emailError, setEmailError] = useState('');

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    if (!value.trim()) {
      setEmailError('');
      return;
    }

    if (!isValidEmail(value)) {
      setEmailError('Please enter a valid email address');
    } else {
      setEmailError('');
    }
  };



  const toggleThankYou = () => setThankYouModal(!thankYouModal);

  // Simple but quite good email validation regex
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();

    const trimmedEmail = email.trim();

    if (!trimmedEmail) {
      toast.error('Please enter your email address', {
        duration: 4000,
        position: 'top-center',
      });
      return;
    }

    if (!isValidEmail(trimmedEmail)) {
      setEmailError('Please enter a valid email address');

      toast.error('Please enter a valid email address', {
        duration: 4000,
        position: 'top-center',
      });
      return;
    }


    const payload = { email: trimmedEmail, formOrigin: 5 };

    try {
      // Show loading toast
      const toastId = toast.loading('Subscribing...', {
        position: 'top-center',
      });

      await NewsLetterService.create(payload);

      // Success!
      toast.dismiss(toastId);
      toast.success('Thank you! You have been subscribed successfully 🎉', {
        duration: 5000,
        position: 'top-center',
      });

      setEmail(''); // clear input
      toggleThankYou(); // show thank you modal

    } catch (error) {
      toast.dismiss();
      console.error('Error submitting email:', error);

      toast.error(
        error.response?.data?.message ||
        'Failed to subscribe. Please try again later.',
        {
          duration: 5000,
          position: 'top-center',
        }
      );
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        width: '100%',
        backgroundColor: countryPage || institutionPage ? '#FFFFFF' : 'transparent',
        height: '410.87px',
        paddingBottom: isMobile ? '5rem' : '1rem',
      }}
    >
      {/* Shine animation styles */}
      <style>{`
        .shine-button {
          position: absolute;
          overflow: hidden;
        }

        .shine-button::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            120deg, 
            transparent, 
            rgba(255, 255, 255, 0.4), 
            transparent
          );
          transition: all 0.6s ease-in-out;
        }

        .shine-button:hover::before {
          left: 100%;
        }
      `}</style>

      <Container fluid>
        <Row>
          <Col lg={12} className="text-start p-0">
            <h1 className="mb-3 font-level-4">STAY CONNECTED WITH US</h1>
            <p className="mb-4 font-level-6">
              Get the latest notification for our events, seminar & offers.
            </p>

            {/* Desktop version */}
            <div className="d-none d-lg-block d-md-block position-relative w-100">
              <input
                type="email"
                value={email}
                onChange={handleEmailChange}
                onKeyPress={handleKeyPress}
                className="w-100 px-4"
                placeholder="Enter Your Email Address"
                style={{
                  paddingTop: '0.75rem',
                  paddingBottom: '0.75rem',
                  paddingRight: '150px',
                  fontSize: 'clamp(0.85rem, 2vw, 1rem)',
                  height: '70.8661px',
                  borderTopRightRadius: '35px',
                  borderBottomRightRadius: '35px',
                  borderTopLeftRadius: '8px',
                  borderBottomLeftRadius: '8px',
                  border: '1.5px solid #687C86',
                }}
              />


              <button
                onClick={handleSubmit}
                className="d-flex align-items-center gap-2 rounded-pill border-0 position-absolute shine-button"
                style={{
                  right: 0,
                  top: 0,
                  bottom: 0,
                  background: 'linear-gradient(to right, #7e1790, #d70a84)',
                  color: 'white',
                  padding: '0 1rem',
                  fontSize: 'clamp(0.5rem, 20.8vw, 0.9rem)',
                  whiteSpace: 'nowrap',
                  cursor: 'pointer',
                  width: window.innerWidth < 500 ? '190px' : '205px',
                  height: '70.8661px',
                }}
              >
                <img
                  src={arrow}
                  alt="arrow"
                  style={{
                    height: '60%',
                    width: 'auto',
                    position: 'relative',
                    zIndex: 1,
                  }}
                />
                <span
                  className="font-level-9"
                  style={{ position: 'relative', zIndex: 1 }}
                >
                  ENTER
                </span>
              </button>
            </div>
            {emailError && (
              <small style={{ color: 'red', marginTop: '6px', display: 'block' }}>
                {emailError}
              </small>
            )}

            {/* Mobile version */}
            <div className="d-block d-md-none position-relative w-100">
              <input
                type="email"
                value={email}
                onChange={handleEmailChange}
                onKeyPress={handleKeyPress}
                className="w-100 px-4"
                placeholder="Enter Your Email Address"
                style={{
                  paddingTop: '0.75rem',
                  paddingBottom: '0.75rem',
                  paddingRight: '150px',
                  fontSize: 'clamp(0.85rem, 2vw, 1rem)',
                  height: '70.8661px',
                  borderTopRightRadius: '35px',
                  borderBottomRightRadius: '35px',
                  borderTopLeftRadius: '8px',
                  borderBottomLeftRadius: '8px',
                  border: '1.5px solid #687C86',
                }}
              />
              <div className="d-flex justify-content-center">
                <button
                  onClick={handleSubmit}
                  className="d-flex align-items-center justify-content-center gap-2 rounded-5 border-0 shine-button mt-2"
                  style={{
                    background: 'linear-gradient(to right, #7e1790, #d70a84)',
                    color: 'white',
                    padding: '0.5rem 1rem',
                    fontSize: 'clamp(0.8rem, 4vw, 1rem)',
                    cursor: 'pointer',
                    width: '50%',
                    height: '60px',
                  }}
                >
                  <img
                    src={arrow}
                    alt="arrow"
                    style={{
                      height: '85%',
                      width: 'auto',
                      position: 'relative',
                      zIndex: 1,
                      left: '-6px',
                    }}
                  />
                  <span
                    className="font-level-9"
                    style={{
                      position: 'relative',
                      zIndex: 1,
                      fontSize: 'clamp(22px, 4vw, 22px)',
                    }}
                  >
                    ENTER
                  </span>
                </button>
              </div>
            </div>
          </Col>
        </Row>

        <FormClose
          modal={thankYouModal}
          toggle={toggleThankYou}
          heading="YOU'RE ONE STEP CLOSER TO STARTING SMART!"
          description="We’ll keep you informed about our latest events, seminars, and special offers."
        />
      </Container>
    </div>
  );
};

export default SmallPage;